<template>
    <div class="view-container">
		<div style="width: 100%; overflow-x: auto">
			<div style="display: flex; flex-direction: column; flex: 1; height: 80vh; min-width: 1500px;">
				<modal :showDialog="activeModal == 'INFO'" @close="closeModal" :title="activeObject != null ? activeObject.column.headerText : ''">
					<system-alarms-details-modal :data="activeObject" :day="activeDay" :apiMethodName="(activeObject != null && activeObject.column.field != 'visits') ? 'getDeviceAlarmFromDay' : 'getVisitsForDay'" :value="activeValue"></system-alarms-details-modal>
				</modal>
				<modal :show-dialog="activeModal === 'SOFTWAREHISTORY'" @close="closeModal" :title="activeObject != null ? activeObject.column.headerText : ''">
					<devices-software-history-modal :device="activeObject"></devices-software-history-modal>
				</modal>
                <modal :showDialog="activeModal == 'LOADCELLDATA'" @close="closeModal" :title="activeDeviceId != null ? 'Calibration ' + systemName : ''">
                  <load-cell-data-modal :systemId="systemId" :deviceId="activeDeviceId"></load-cell-data-modal>
                </modal>
				<ejs-grid ref="grid" height="100%" width="100%" :toolbar="toolbar" :toolbarClick="toolbarClick" :sortSettings="sortSettings" :selectionSettings="selectionOptions" :allowTextWrap="true" :textWrapSettings="wrapSettings" :dataBound="dataBound" :dataSource="data" :allowPaging="true" :pageSettings="pageSettings" :allowFiltering="true" :filterSettings="filterOptions" :allowSorting="true" :allowMultiSorting='true' :allowPdfExport='true' :allowCsvExport='true' :allowExcelExport='true' :showBusyIndicator="true" style="position: relative" :excelExportComplete='exportComplete' :pdfExportComplete='exportComplete'>
					<e-columns>
						<e-column field="number" :headerText="'Number'" textAlign="Left" :customAttributes="customAttributes"></e-column>
						<e-column field="type" :headerText="'Type'" textAlign="Left" :customAttributes="customAttributes"></e-column>
						<e-column field="mode" :headerText="'Mode'" textAlign="Left" :template="modeTemplate" :customAttributes="customAttributes"></e-column>
						<e-column field="deviceVersion" :template="buttonTemplate" :headerText="'Software'" textAlign="Left" :customAttributes="customAttributes"></e-column>
						<e-column field="status" :headerText="'Status'" textAlign="Left" :template="statusTemplate" :customAttributes="customAttributes"></e-column>
						<e-column field="calibration" onClick="showCalibration" :headerText="'Calibration'" textAlign="Left" :template="calibrationTemplate" :customAttributes="customAttributes"></e-column>
						<e-column field="photocell" :headerText="'Photocell'" :template="StatusTemplate" textAlign="Left" :customAttributes="customAttributes"></e-column>
						<e-column field="loadcell" :headerText="'Loadcell'" :template="StatusTemplate" textAlign="Left" :customAttributes="customAttributes"></e-column>
						<e-column field="connection" :headerText="'Connection'" :template="StatusTemplate" textAlign="Left" :customAttributes="customAttributes"></e-column>
						<e-column field="visits" :headerText="'Visits'" :template="StatusTemplate" textAlign="Left" :customAttributes="customAttributes"></e-column>
						<e-column field="errorLogs" :headerText="'Error Logs'" :template="StatusTemplate" textAlign="Left" :customAttributes="customAttributes"></e-column>
						<e-column field="lid" :headerText="'Lid'" textAlign="Left" :template="lidTemplate" :customAttributes="customAttributes"></e-column>
						<e-column field="tilt" :headerText="'Tild'" textAlign="Left" :template="tiltTemplate" :customAttributes="customAttributes"></e-column>
						<e-column field="initPhotodelay" :headerText="'Init Photodelay'" textAlign="Left" :template="initPhotodelayTemplate" :customAttributes="customAttributes"></e-column>
						<e-column field="photodelay" :headerText="'Photodelay'" textAlign="Left" :template="photodelayTemplate" :customAttributes="customAttributes"></e-column>
					</e-columns>
				</ejs-grid>
			</div>
		</div>

    </div>
</template>
<script>
import { getSystemDevices, deleteDevice, getDeviceAlarms } from '@api'
import { Sort, Page, Filter, Toolbar, Search, CommandColumn, PdfExport, ExcelExport } from '@syncfusion/ej2-vue-grids';
import Vue from 'vue'
import SystemStatus from "@/components/Systems/SystemStatus"
import SystemAlarmsDetailsModal from '../components/Systems/SystemAlarmsDetailsModal.vue';
import Modal from '../components/Modal.vue';
import DevicesSoftwareHistoryModal from "../components/Systems/Devices/DevicesSoftwareHistoryModal";
import LoadCellDataModal from '../components/Devices/LoadCellDataModal';

var context = null

export default {
    props: ['systemName', 'systemId'],
    components: {
		DevicesSoftwareHistoryModal,
		  SystemAlarmsDetailsModal,
		  Modal,
      LoadCellDataModal,
    },
    provide: {
        grid: [ Sort, Page, Filter, Toolbar, Search, CommandColumn, PdfExport, ExcelExport ]
    },
    data() {
        return {
            data: [],
            activeModal: "NONE",
      		  activeObject: null,
			      activeDay: null,
			      activeValue: null,
            activeDeviceId: null,
            pageSettings: { pageSize: 100, pageSizes: [10, 25, 50, 100] },
			toolbar: [
                { text: this.systemName + '\t>', id: 'table-title'},
                { text: this.$t('Devices'), id: 'table-device-title',},
                { text: this.$t('ClearFilter'), id: 'clear-filters', prefixIcon: 'e-cancel', align: 'Right',},
                { text: this.$t('Excelexport'), prefixIcon: 'e-excelexport', align: 'Right', id: 'excel-export'},
                { text: this.$t('Pdfexport'), prefixIcon: 'e-pdfexport', align: 'Right', id: 'pdf-export'},
                { text: this.$t('Csvexport'), prefixIcon: 'e-csvexport', align: 'Right', id: 'csv-export'},

				'Search',
			],
            sortSettings: {
                columns: [
                    { field: 'number', direction: 'Ascending' }
                ]
            },
			wrapSettings: { wrapMode: "Content" },
			selectionOptions: { type: "Multiple" },
			filterOptions: {
				type: "Menu",
			},
			customAttributes: { class: "customcss" },
            StatusTemplate: function () {
              return {
                template: {
                  extends: SystemStatus,
                  propsData: {
                    callback: (data, mode, day, value) => {
                      context.showModal(data, mode, day, value)
                    }
                  }
                },
              };
            },
			buttonTemplate: function() {
            	return {
            		template: Vue.component('buttonTemplate', {
            			template: `<button v-on:click="openModal" class="device-software-version-button">{{text}}</button>`,
						data: function() {
            				return {
            					data: {}
            				}
						},
						computed: {
            				text() {
            					return this.data.deviceVersion
							}
						},
						methods: {
            				openModal(){
            					// console.log(this.data)
								context.showModal(this.data, 'SOFTWAREHISTORY', null, null)
							}
						}
					})
				}
			},
            modeTemplate: function() {
                return {
                    template: Vue.component('modeTemplate', {
                        template: `<div>{{mode}}</div>`,
                        data: function() {
                                return {
                                    data: {},
                                }
                            },
                        computed: {
                            mode: function() {
                                return ["Normal", "Restricitve", "Free Access"][this.data.mode]
                            }
                        },
                    })
                }
            },
            statusTemplate: function() {
                return {
                    template: Vue.component('statusTemplate', {
                        template: `<div>{{status}}</div>`,
                        data: function() {
                                return {
                                    data: {},
                                }
                            },
                        computed: {
                            status: function() {
                                return this.data.status != null ? ["Up", "Down"][this.data.status] : "-"
                            }
                        },
                    })
                }
            },
            lidTemplate: function() {
                return {
                    template: Vue.component('lidTemplate', {
                        template: `<div>{{status}}</div>`,
                        data: function() {
                                return {
                                    data: {},
                                }
                            },
                        computed: {
                            status: function() {
                                return this.data.lid ? "Open" : "Close"
                            }
                        },
                    })
                }
            },
            tiltTemplate: function() {
                return {
                    template: Vue.component('tiltTemplate', {
                        template: `<div>{{tilt}}</div>`,
                        data: function() {
                                return {
                                    data: {},
                                }
                            },
                        computed: {
                            tilt: function() {
                                return this.data.tilt ? "Open" : "Close"
                            }
                        },
                    })
                }
            },
            calibrationTemplate: function() {
                return {
                    template: Vue.component('calibrationTemplate', {
                        template: `<div style="cursor: pointer;" v-on:click="showModal()" id="calibrationId">{{tilt}}</div>`,
                        data: function() {
                                return {
                                    data: {},
                                }
                            },
                        computed: {
                            tilt: function() {
                                return this.data.calibration.includes("0001-01-01T01:00:00") ? "-" : this.data.calibration.split("T")[0]
                            }
                        },
                        methods: {
                          showModal: function() {
                            context.showCalibrationModal(this.data);
                          }
                        }
                    })
                }
            },
            initPhotodelayTemplate: function() {
                return {
                    template: Vue.component('initPhotodelayTemplate', {
                        template: `<div>{{init}}</div>`,
                        data: function() {
                                return {
                                    data: {},
                                }
                            },
                        computed: {
                            init: function() {
                                return this.data.initPhotodelay + 's'
                            }
                        },
                    })
                }
            },
            photodelayTemplate: function() {
                return {
                    template: Vue.component('photodelayTemplate', {
                        template: `<div>{{photodelay}}</div>`,
                        data: function() {
                                return {
                                    data: {},
                                }
                            },
                        computed: {
                            photodelay: function() {
                                return this.data.photodelay + "s"
                            }
                        },
                    })
                }
            }
        }
    },
    methods: {
        async getData() {
            this.$store.dispatch('set_loading', true)
            this.data = await getSystemDevices(this.systemId);
            this.$store.dispatch('set_loading', false)
        },
        dataBound: function () {
          this.$refs.grid.autoFitColumns();
        },
        toolbarClick: function (args) {
          switch (args.item.id) {
            case "table-system-title":
              this.$router.push({
											name: "systems"
										})
              break;
            case "table-device-title":
              this.getData();
              break;
            case "pdf-export":
              this.data.forEach((item) => {
                item.photocell.reverse()
                item.loadcell.reverse()
                item.connection.reverse()
                item.visits.reverse()
                item.errorLogs.reverse()
              })
              this.$refs.grid.pdfExport();
              break;
            case "csv-export":
              this.data.forEach((item) => {
                item.photocell.reverse()
                item.loadcell.reverse()
                item.connection.reverse()
                item.visits.reverse()
                item.errorLogs.reverse()
              })
              this.$refs.grid.csvExport();
              break;
            case "excel-export":
              this.data.forEach((item) => {
                item.photocell.reverse()
                item.loadcell.reverse()
                item.connection.reverse()
                item.visits.reverse()
                item.errorLogs.reverse()
              })
              this.$refs.grid.excelExport();
              break;
            case 'clear-filters':
                this.$refs.grid.clearFiltering();
                break;
          }
        },
        exportComplete(args) {
          this.data.forEach((item) => {
            item.photocell.reverse()
            item.loadcell.reverse()
            item.connection.reverse()
            item.visits.reverse()
            item.errorLogs.reverse()
          })
        },
        showModal(obj, mode, day, value){
        //   console.log(obj, day, mode, value)
          this.activeObject = obj
          this.activeDay = day
          this.activeModal = mode
          this.activeValue = value
        },
        closeModal(mode){
          this.activeModal = 'NONE'
          this.activeObject = null
          this.activeDay = null
          this.activeValue = null
          if(mode == 'getData')
            this.getData()
        },
        showCalibrationModal(data) {
          this.activeDeviceId = data.id
          this.activeModal = 'LOADCELLDATA'
        }
    },
    mounted: async function () {
        context = this
        await this.getData()
    }
}
</script>

<style>
.device-software-version-button {
	border: 1px #ddd solid;
	padding: 5px 10px;
	background: none;
}

.device-software-version-button:hover {
	background: #bbbbbb;
}

</style>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Devices.vue